import { render, staticRenderFns } from "./PopupChat.vue?vue&type=template&id=4581b66a&scoped=true"
import script from "./PopupChat.vue?vue&type=script&lang=js"
export * from "./PopupChat.vue?vue&type=script&lang=js"
import style0 from "./PopupChat.vue?vue&type=style&index=0&id=4581b66a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581b66a",
  null
  
)

export default component.exports